import React, { useEffect } from 'react';
import { Rating as ReactRating, ThinStar } from '@smastrom/react-rating';
import styles from './styles.module.css';
import useWindowDimensions from '@/functions/useWindowDimensions';

export default function RateComponent({
  number = 5,
  rate = 0,
  widgetDimensions = '12px',
  className = '',
  onChange = (x) => {},
  readOnly = true,
  title,
  activeFillColor,
}: {
  number?: 5 | 2 | 10 | 1 | 3 | 4 | 6 | 7 | 8 | 9 | undefined;
  rate?: number;
  widgetDimensions?: string;
  className?: string;
  onChange?: (x: number) => void;
  readOnly?: boolean;
  title?: string | null;
  activeFillColor?: string;
}) {
  const { width } = useWindowDimensions();

  const displayRate = Math.round(rate * 2) / 2; // rounds 2.6 → 2.5
  return (
    <div className={` ${styles.container} ${!onChange && styles.readonly} ${className}`}>
      {title && <span>{title}</span>}

      <ReactRating
        key={width && width < 941 ? 'mobile' : 'desktop'}
        value={number === 1 ? Math.min(rate / 5, 1) : rate}
        items={number}
        readOnly={readOnly}
        onChange={onChange}
        halfFillMode={!onChange ? 'svg' : undefined} // show half stars only in readonly mode
        style={{ maxWidth: `${number * parseInt(widgetDimensions, 10)}px` }}
        itemStyles={{
          itemShapes: ThinStar,
          inactiveFillColor: 'var(--line-strong)',
          activeFillColor: activeFillColor ? activeFillColor : 'var(--amber)',
        }}
      />
    </div>
  );
}
